import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'arrayTranspose' })
export class ArrayTransposePipe implements PipeTransform {

  /* transform(): Pipe que sirve para trasponer una matriz
    value: Matriz a trasponer
  */
  transform = (value: any[]): any[] => Object.keys(value[0]).map((col: any) => value.map((row: any) => row[col]));

}
